import type { RevenueReportComponentProps } from './RevenueReportComponent';

export const RevenueReportComponent = {
    MountAsync: async (target: HTMLElement, props: RevenueReportComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { RevenueReportComponent } = await import('./RevenueReportComponent');
        return await mountReactComponentAsync(target, RevenueReportComponent, props);
    }
};
